import { inject, Pipe, PipeTransform } from "@angular/core";
import { MaskingStore } from "../stores/masking.store";

/**
 * 이름 마스킹 파이프
 * 예: 김철수 → 김*수, 홍길동 → 홍*동
 */
@Pipe({
    name: "maskName",
    standalone: true,
    pure: false,
})
export class MaskNamePipe implements PipeTransform {
    private store = inject(MaskingStore);

    transform(value: string | null | undefined): string {
        if (!this.store.isMaskingEnabled()) {
            return value || "-";
        }

        if (!value || value.length < 2) return value || "-";

        const chars = [...value];
        // 짝수 인덱스(1, 3, 5...)를 마스킹
        for (let i = 1; i < chars.length; i += 2) {
            chars[i] = "*";
        }
        return chars.join("");
    }
}
